import { CalendarDays, Plus } from "lucide-react";
import { AccountMenu } from "@/components/shell/AccountMenu";
import { WorkspaceHeader, type WorkspaceNavItem } from "@/components/shell/WorkspaceHeader";
import { BookedTripsView } from "@/components/booked-trips/BookedTripsView";

// =============================================================================
// /booked
//
// Every trip on the books for a date, under the same workspace bar as the
// trip request form (New trip / Booked trips, account menu). The route is
// gated on viewBookedTrips (see App.tsx), so both tabs always apply here.
// =============================================================================

const NAV: WorkspaceNavItem[] = [
  { to: "/", label: "New trip", icon: Plus, end: true },
  { to: "/booked", label: "Booked trips", icon: CalendarDays },
];

export function BookedTripsPage() {
  return (
    <>
      <WorkspaceHeader nav={NAV} trailing={<AccountMenu />} />
      <main
        id="main-content"
        className="page-in mx-auto w-full max-w-[1280px] scroll-mt-16 px-4 pb-12 pt-6 sm:px-6 sm:pt-10"
      >
        <BookedTripsView />
      </main>
    </>
  );
}
